import _ from 'lodash';
import React, { Component } from 'react';
import { BasePopoverPanel } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { connect } from 'react-redux';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import PropTypes from 'prop-types';
import Radium from 'radium';
import FontEmphasisAndAlign from '../FontEmphasisAndAlign';
import styles from './FontMoreActionsPanelStyles';
import Divider from 'material-ui/Divider';
import { HyperlinkButton, renderModes as hyperLinkRenderModes } from '../../HyperlinkProperty/HyperlinkButton';

@connect(
  false,
  {closeLazyPanel}
)
@Radium
export default class FontMoreActionsPanel extends Component {
  onClose = () => {
    const { closeLazyPanel, panelName } = this.props;
    closeLazyPanel(panelName);
  };

  render() {
    const { panelName, anchorEl, open, panelProps } = this.props;
    const { isMobileView, selectedElements } = panelProps;
    return (
      <BasePopoverPanel
        panelName={panelName}
        anchorEl={anchorEl}
        open={open}
        onRequestClose={this.onClose}
        style={{padding: '20px'}}
      >
        <div style={styles.sectionTitle}>Font</div>
        <div>
          <FontEmphasisAndAlign isMobileView={isMobileView} style={{margin: 0, top: 0}}/>
        </div>
        {!isMobileView &&
        [ <Divider key="1" style={styles.divider}/>,
          <div key="2" style={{paddingTop: '20px', textAlign: 'center'}}>
            <div style={styles.sectionTitle}>Hyperlink</div>
            <HyperlinkButton mode={hyperLinkRenderModes.HORIZONTAL} selectedElements={selectedElements}
                             onClick={this.onClose}/>
          </div>
        ]}
      </BasePopoverPanel>
    );
  }
}

FontMoreActionsPanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  panelProps: PropTypes.shape({
    selectedElements: PropTypes.array.isRequired,
    isMobileView: PropTypes.bool.isRequired
  })
};